<template>
  <Space class="settings-box" :padding-x="18" :padding-y="12" :space="8">
    <Space :space="1">
      <Text as="h2" size="text-md" weight="semibold" color="color-text-text-secondary-700">
        {{ title }}
      </Text>
      <Text as="p" color="color-text-text-tertiary-600" size="text-sm">
        {{ description }}
      </Text>
    </Space>
    <slot />
  </Space>
</template>

<script lang="ts" setup>
  import { Space } from '@/components/Space'
  import { Text } from '@/components/ui'

  defineProps<{
    description: string
    title: string
  }>()
</script>
